// extracted by mini-css-extract-plugin
export default {"accuracyModal":"AccuracyModal_accuracyModal__Q+AaR","header":"AccuracyModal_header__08Uq3","body":"AccuracyModal_body__iOufq","footer":"AccuracyModal_footer__IUUF+"};